__webpack_require__.p = "https://static.spqr.app/ffec20eff5e0d8cc420f97d86d083ccdc4fc93d3/_next/";